// extracted by mini-css-extract-plugin
module.exports = {"module":"TrackingStatus_module__1J8eJ","positive":"TrackingStatus_positive__1puP3","negative":"TrackingStatus_negative__iO_L8"};